module.exports = __webpack_public_path__ + "static/media/wind.41d27702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather/wind.png
// module id = 519
// module chunks = 0